import { SliderDataAttrs } from "../slider/data.js";
//#region src/core/ui/volume-slider/data.ts
/** @internal */
const VolumeSliderDataAttrs = {
	...SliderDataAttrs,
	availability: "data-availability",
	hidden: "data-hidden"
};
//#endregion
export { VolumeSliderDataAttrs };

//# sourceMappingURL=data.js.map